'use client';

import { useEvent } from 'react-use';

const BUILD_TIMESTAMP = process.env.NEXT_PUBLIC_BUILD_TIMESTAMP;
const EXPIRY_BUFFER_MS = 5 * 24 * 60 * 60 * 1000; // 5 days

export function ChunkExpiryHandler() {
  useEvent('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;

    const buildTime = parseInt(BUILD_TIMESTAMP || '', 10);
    if (isNaN(buildTime)) return;

    if (Date.now() - buildTime >= EXPIRY_BUFFER_MS) {
      window.location.reload();
    }
  });

  return null;
}
